import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsSearchRoute: InvariantJiraRoute = {
	name: 'assets-search-results',
	path: '/jira/assets/search',
	exact: true,
};
